// Geometry shared by the prompt card, its skeleton, and their tests. Used as element attributes and
// props, not inside styles — style values are restated as local literals per component, because
// `ui-styling-standard/no-imported-style-values` bans imported values there.

export const PROMPT_CARD_MAX_LINES = 2;

export const PROMPT_CARD_ICON_SIZE = 24;
export const PROMPT_CARD_ICON_GAP = 'space.100' as const;

// The artwork components carry this size themselves; the tests assert they still match.
// The drawn stack is 317x122 and the rest is shadow bleed.
export const CARD_STACK_WIDTH = 333;
export const CARD_STACK_HEIGHT = 135;

export const CARD_STACK_ICON_SIZE = 24;
